import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=052e4e2e&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=052e4e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e4e2e",
  null
  
)

export default component.exports